import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import {CookieService} from 'ngx-cookie';
import * as moment from "moment";
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class DataAvailabilityService {
  readonly baseURL = DDP_ENV.webdataUrl;
  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllDataAvailable(campaignId, startDate, endDate, page, size) {
    if (campaignId !== undefined) {
      let url = this.baseURL + '/data-available/campaign/' + campaignId + '?startDate='+startDate+'&endDate='+endDate+'&page=' + page + '&size=' + size;
      // tslint:disable-next-line:max-line-length
        return this._http.get(url, this.buildHeaders());
    }
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

}
